import { DateTime } from 'luxon';
import { useMemo } from 'react';

export const useCalendar = (baseDate: DateTime) => {
  if (!baseDate.isValid) return null;

  return useMemo(() => {
    const currentMonth = baseDate.startOf('month');
    const startOfCalendar = currentMonth.startOf('week');
    const endOfCalendar = currentMonth.endOf('month').endOf('week');

    const days: DateTime[] = [];
    let cursor = startOfCalendar;

    while (cursor <= endOfCalendar) {
      days.push(cursor);
      cursor = cursor.plus({ days: 1 });
    }

    const weeks: DateTime[][] = [];

    for (let i = 0; i < days.length; i += 7) {
      weeks.push(days.slice(i, i + 7));
    }

    return {
      currentMonth,
      startOfCalendar,
      endOfCalendar,
      days,
      weeks,
    };
  }, [baseDate.toISODate()]);
};
